import { atom } from 'recoil';

export const closeModalControl = atom({
  key: 'closeModalControl',
  default: false,
});
